export type QiCardUiState =
  | "pending"
  | "success"
  | "failed"
  | "cancelled"
  | "timeout";

export function mapQiStatusToUi(status: string | undefined): QiCardUiState | null {
  const normalized = String(status ?? "").trim().toUpperCase();

  if (!normalized) return null;

  if (normalized === "SUCCESS") return "success";

  if (
    normalized === "FAILED: CANCELED" ||
    normalized.includes("CANCEL")
  ) {
    return "cancelled";
  }

  if (normalized === "FAILED" || normalized === "AUTHENTICATION_FAILED") {
    return "failed";
  }

  if (
    normalized === "CREATED" ||
    normalized === "UNKNOWN" ||
    normalized === "PENDING" ||
    normalized === "FORM_SHOWED"
  ) {
    return "pending";
  }

  return null;
}

/** User came back from Q Pay without a completed charge. */
export function isQiCardIncompleteCheckoutStatus(
  status: string | undefined
): boolean {
  const normalized = String(status ?? "").trim().toUpperCase();
  return normalized === "FORM_SHOWED" || normalized === "CREATED";
}

export function isQiCardTerminalStatus(status: string | undefined): boolean {
  const ui = mapQiStatusToUi(status);
  return ui === "success" || ui === "failed" || ui === "cancelled";
}
